import React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import {Button} from "@mui/material";
import {formatTimestampWithDOW} from "../../utils";

let onBiddingClick;
const renderBiddingButton = (params) => {
    //TODO: if phase is not DRAFT do not show bidding button...
    const onClick = async () => {
        onBiddingClick(params.row)
    }
    return (
        <Button color="primary" onClick={onClick} style={{padding: 0}}>Bidding</Button>
    );
};

const common = {sortable: false, disableColumnMenu: true, headerClassName: 'grid-header'};
const bidGroupListColumns = [
    {...common, width: 130, headerName: 'First Name', field: 'first_name'},
    {...common, width: 170, headerName: 'Last Name', field: 'last_name'},
    {...common, width: 60, headerName: 'Pos', field: 'pos', headerAlign: 'center', align: 'center'},
    {...common, width: 70, headerName: 'Team', field: 'team', headerAlign: 'center', align: 'center'},
    {...common, width: 200, headerName: 'Game Time', field: 'game_time', headerAlign: 'left', align: 'left', valueGetter: v => v ? formatTimestampWithDOW(v) : ''},
    {...common, width: 90, headerName: 'High Bid', field: 'high_bid', type: 'number', headerAlign: 'right'},
    {...common, width: 110, headerName: 'High Bidder', field: 'high_bidder', headerAlign: 'center', align: 'center'},
    {...common, width: 105, headerName: ' ', field: 'bidding', align: 'center', renderCell: renderBiddingButton}
];

const calcWidth = (cols) => {
    return cols.reduce((t, c) => t + c.width, 0) + 2;
};
const determineRowClass = (params) => {
    return `${params.row.row_number % 2 === 1 ? 'table-row-odd' : 'table-row-even'}`
};

export const BidGroupGrid = ({rows, onBiddingButtonClick}) => {
    onBiddingClick = onBiddingButtonClick;
    return (
        <div style={{width: calcWidth(bidGroupListColumns)}}>
            <DataGrid columns={bidGroupListColumns} rows={rows} hideFooter={true}
                      columnHeaderHeight={30} rowHeight={23}
                      getRowClassName={(params) => (determineRowClass(params))}
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
}
